import React, { Component } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth , scrollToTopValidate, scrollToTop} from "../Helpers/SettingHelper";
import { apiUrl,  mediaUrl, assetUrl} from'../Config/Config';
import axios from 'axios';
import { ShadowPicker } from "react-shadow-picker";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };


class Edit extends Component {
	fileObj = [];
    fileArray = [];
    imageArray = [];
	
	constructor(props)
	{
		CheckAuth();
		super(props);	
		const themeID = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		this.state = {			
			
			statusmessage:'',
			c_theme_id: themeID,
			title:'',
			
			status:'active',
		    selectedFile: null,
			Loading:false,
			LoadingCloneBtn:false,
			selectedvalue: '',
            selectedOption:{ value: 'active', label: 'Active'},
			selectedFileCount : 0,

			shadow: "",
			shadows: {
				shadowPluginOpenButton: "0px 2px 36px #0404052e",
				shadowPluginOpenButtonInset: "inset 5px 0px 5px 0px #3434372b",
				largeButton: "0 4px 18px 0 #0404052e",
				shadowButtonInset: "0 4px 18px 0 #0404052e",
				shadowDropdownMenu: "0px 12px 30px #0404052e",
				shadowDropdownMenuInset: "0px 12px 30px #0404052e",
				dashboardShadowGrid: "0 10px 21px 0 #0000001c",
				shadowDashboardGridInset: "0 10px 21px 0 #0000001c",
				dashboardShadowList: "0 21px 21px 0 #0000001c",
				shadowDashboardListInset: "0 21px 21px 0 #0000001c",
				shadowAISidebar: '1px 0px #0000000c',
				shadowAISidebarInset: '1px 0px #0000000c',
				shadowTopPopup: '1px 0px #0000000c',
				shadowTopPopupInset: '1px 0px #0000000c',
				shadowFormGroup: '0px 3px 21px 0px #9f99995c',
				shadowFormGroupInset: '1px 0px #0000000c',
				shadowLeftSidebar: "0px 3px 21px 0px #9f99995c",
				shadowLeftSidebarInset: "0px 3px 21px 0px #9f99995c",
				shadowRightSidebar: "0px 3px 21px 0px #9f99995c",
				shadowRightSidebarInset: "0px 3px 21px 0px #9f99995c",
				shadowSearchDropdown: "0px 40px 50px -40px #3434375E",
				shadowSearchDropdownInset: "inset 5px 0px 5px 0px #3434372b",
				shadowListRow: '0px 15px 10px -15px #0404052e',
				shadowTableRow: '0px 7px 8px -7px #0404052e',
				shadowPluginInsetLeft: "inset 15px 0 10px -10px #2727272b",
				shadowPluginInsetRight: "",
				shadowPluginInsetTop: "",
				shadowPluginInsetBottom: "",
				pluginShadow: "0px 24px 34px #0404052e",
				shadowInput: "5px 0px 5px 0px #3434372b",
				shadowText: "0 7px 10px -7px #04040422",
				textarea: "0 7px 10px -7px #04040422",				
				//sideMenu: "-2px 10px 15px #3434375e",
				//shortcutMenu: "0px 3px 21px 0px #9f99995c",
				// shadowPluginInset: "inset 5px 0px 15px 0 #3434372b",
				shadowMainAITextarea: "inset 5px 0px 5px 0px #3434372b",
			},
			activeShadowType: "largeButton",

			st_aisidebar_width  : '320',
			st_aisidebar_collapsed_width  : '60',
			st_aisidebar_icon_width  : '30',
			line_height    	: '1.5',
			pluginRadius    : '30',
			dropdownRadius  : '10',
			inputRadius    	: '10',
			textareaRadius  : '10',
			listRowRadius  : '10',
			dashboardGridRadius  : '10',
			dashboardListRadius  : '10',
			imageSliderRadius  : '10',
			formGroupRadius  : '10',
			formAction: "edit", // default


			// fontDetails: [
			// 	{ index: 1, FontType: "primary", listName: "Primary", FontSize: "22", FontWeight: "500", letterSpacing: "2", lineHeight: "1.5", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 2, FontType: "mainTab", listName: "Main Tab", FontSize: "22", FontWeight: "600", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 3, FontType: "sideMenu", listName: "Side Menu", FontSize: "22", FontWeight: "500", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 4, FontType: "title", listName: "Title", FontSize: "22", FontWeight: "800", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 5, FontType: "subTitle", listName: "Sub Title", FontSize: "22", FontWeight: "700", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 6, FontType: "listFont", listName: "List Font", FontSize: "22", FontWeight: "500", letterSpacing: "2", lineHeight: "1.5", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 7, FontType: "listTitleFont", listName: "List Title Font", FontSize: "22", FontWeight: "700", letterSpacing: "2", lineHeight: "1.5", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 8, FontType: "listSerialNoFont", listName: "List Serial No Font", FontSize: "22", FontWeight: "700", letterSpacing: "1.5", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 9, FontType: "menuLogo", listName: "Menu Logo", FontSize: "28", FontWeight: "700", letterSpacing: "2", lineHeight: "1.5", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 10, FontType: "dashboardList", listName: "Dashboard List", FontSize: "22", FontWeight: "700", letterSpacing: "1.5", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 11, FontType: "dashboardListCount", listName: "Dashboard List Count", FontSize: "22", FontWeight: "700", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 12, FontType: "largebutton", listName: "Large Button", FontSize: "22", FontWeight: "700", letterSpacing: "2", lineHeight: "1.5", TopSpace: "12", BottomSpace: "11", radius: "11" },
			// 	{ index: 13, FontType: "smallbutton", listName: "Small Button", FontSize: "22", FontWeight: "700", letterSpacing: "2", lineHeight: "1.5", TopSpace: "8", BottomSpace: "3", radius: "11" },
			// 	{ index: 14, FontType: "pluginOpenButton", listName: "Plugin Open Button", FontSize: "32", FontWeight: "700", letterSpacing: "2", lineHeight: "", TopSpace: "14", BottomSpace: "10", radius: "11" },
			// 	{ index: 15, FontType: "listStoreName", listName: "List Store Name", FontSize: "22", FontWeight: "600", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 16, FontType: "detailProductDesc", listName: "Product Detail Desc", FontSize: "22", FontWeight: "500", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 17, FontType: "mainAISidebarChatSummaryTitle", listName: "AI Chat Summary Title", FontSize: "22", FontWeight: "700", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 18, FontType: "mainAISidebarChatSummary", listName: "AI Chat Summary", FontSize: "22", FontWeight: "500", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// 	{ index: 19, FontType: "mainAISidebarProfile", listName: "AI Profile Dropdown", FontSize: "11", FontWeight: "500", letterSpacing: "2", lineHeight: "", TopSpace: "", BottomSpace: "", radius: "" },
			// ],
			fontDetails: [
				
			],		
			fonttype: [],
			selectedFont: "",
			selectedFontVariant: "",
			st_varient_id: [],

			settingsNotesPopup: false,
			infoSliderName: '',
			showClonePopup: false,
      		cloneTitle: "",
		};
		
		

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleInputPopupChange = this.handleInputPopupChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);
		//console.log(this.state.c_company_id+"-test");

    }
	

    handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
   	handleInputChange(event) {
      	const {name, value} = event.target;      
      	this.setState({
        	[name]: value
        });
    }
	handleInputPopupChange(event) {
      const {name, value} = event.target;      
      this.setState({
        [name]: value
      });
    }

	componentDidMount() {
		document.title = PageTitle('Theme Edit');
		this.newDataloader();   

		var admin_id = localStorage.getItem('admin_id');
		axios.get(apiUrl+'font/getfont_name?admin_id='+admin_id).then(res => {
			if(res.data.status == 'success'){
				this.setState({
					fonttype: res.data.fontlist
				})
			}
		});
    }
	newDataloader = (r=null) =>{
		axios.get(apiUrl+"thememanagement/listdetail?id="+this.state.c_theme_id).then(res => {
			if(res.data.status === "success"){

				const formdata = res.data.themelist;
				if(formdata.status === 'A'){
					this.setState({selectedOption:{value: 'active', label: 'Active'}});
				}else{
					this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
				}
				
				this.setState({title:formdata.title,st_aisidebar_width:formdata.st_aisidebar_width,st_aisidebar_collapsed_width:formdata.st_aisidebar_collapsed_width,st_aisidebar_icon_width:formdata.st_aisidebar_icon_width, line_height:formdata.lineHeight,pluginRadius:formdata.pluginRadius,dropdownRadius:formdata.dropdownRadius,inputRadius:formdata.inputRadius,textareaRadius:formdata.textareaRadius,dashboardGridRadius:formdata.dashboardGridRadius,dashboardListRadius:formdata.dashboardListRadius,listRowRadius:formdata.listRowRadius, imageSliderRadius : formdata.imageSliderRadius, formGroupRadius : formdata.formGroupRadius});
				
				const shadowRecord = res.data.themeShadowRecord;
				const newShadows = {
					shadowPluginOpenButton: shadowRecord.shadowPluginOpenButton,
					shadowPluginOpenButtonInset: shadowRecord.shadowPluginOpenButtonInset,
					largeButton: shadowRecord.button_shadow,
					shadowButtonInset: shadowRecord.shadowButtonInset,
					shadowDropdownMenu: shadowRecord.shadowDropdownMenu,
					shadowDropdownMenuInset: shadowRecord.shadowDropdownMenuInset,
					dashboardShadowGrid: shadowRecord.dashboard_shadow_grid,
					shadowDashboardGridInset: shadowRecord.shadowDashboardGridInset,
					dashboardShadowList: shadowRecord.dashboard_shadow_list,
					shadowDashboardListInset: shadowRecord.shadowDashboardListInset,
					shadowAISidebar: shadowRecord.shadowAISidebar,
					shadowAISidebarInset: shadowRecord.shadowAISidebarInset,
					shadowTopPopup: shadowRecord.shadowTopPopup,
					shadowTopPopupInset: shadowRecord.shadowTopPopupInset,
					shadowFormGroup: shadowRecord.shadowFormGroup,
					shadowFormGroupInset: shadowRecord.shadowFormGroupInset,
					shadowLeftSidebar: shadowRecord.shadowLeftSidebar,
					shadowLeftSidebarInset: shadowRecord.shadowLeftSidebarInset,
					shadowRightSidebar: shadowRecord.shadowRightSidebar,
					shadowRightSidebarInset: shadowRecord.shadowRightSidebarInset,
					shadowSearchDropdown: shadowRecord.shadowSearchDropdown,
					shadowSearchDropdownInset: shadowRecord.shadowSearchDropdownInset,
					shadowListRow: shadowRecord.shadowListRow,
					shadowTableRow: shadowRecord.shadowTableRow,
					shadowPluginInsetLeft: shadowRecord.shadowPluginInsetLeft,
					shadowPluginInsetRight: shadowRecord.shadowPluginInsetRight,
					shadowPluginInsetTop: shadowRecord.shadowPluginInsetTop,
					shadowPluginInsetBottom: shadowRecord.shadowPluginInsetBottom,
					pluginShadow: shadowRecord.plugin_shadow,
					shadowInput: shadowRecord.shadowInput,
					shadowText: shadowRecord.shadowText,
					// sideMenu: shadowRecord.sidemenu_shadow,
					// shortcutMenu: shadowRecord.shortcut_shadow,
					textarea: shadowRecord.textarea_shadow,					
					//shadowPluginInset: shadowRecord.shadowPluginInset,
					shadowMainAITextarea: shadowRecord.shadowMainAITextarea,
				};
				this.setState({ shadows: newShadows });

				if(res.data.themeFontRecord.length>0)
				{
					this.setState({ fontDetails: res.data.themeFontRecord }, () => {
						// 🔹 After setting fontDetails, preload variants
						this.state.fontDetails.forEach((font, idx) => {
							if (font.font_id) {
								this.preloadFontVariants(font.font_id, idx);
							}
						});
					});
				}else{
					this.setState({
						fontDetails: [
							{
							index: Math.random(),
							FontType: "",
							FontSize:'',
							FontWeight:'',
							letterSpacing:'',
							lineHeight:'',
							TopSpace:'',
							BottomSpace:'', 
							radius:'', 
							varient_id : "",
							}
						]
					});
				}
			}
		}); 
	}
	preloadFontVariants = async (fontValue, idx) => {
		try {
		// Find label from fonttype list
		//const selectedFont = this.state.fonttype.find(f => f.value == fontValue);
		const selectedFont = this.state.fonttype.find(f => f.value.toString() === fontValue.toString());
		const fontLabel = selectedFont ? selectedFont.label : "";

		const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
			params: {
				id: fontValue,
				...(fontLabel && { name: fontLabel }),
			},
		});

		if (response.data.variants) {
			let fontDetails = [...this.state.fontDetails];
			fontDetails[idx] = {
			...fontDetails[idx],
			variants: response.data.variants,
			};
			this.setState({ fontDetails });
		}
		} catch (error) {
		console.error("Error preloading font variants:", error);
		}
	};
	

	handleFormSubmit = () => {
		if(this.validateForm()){ 
			
			const formPayload = this.state;
			var qs = require('qs');
			var status = '';
			if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
			status =formPayload.selectedOption.value;
			}else{
			status = formPayload.selectedvalue;
			}
			var postObject = {
				admin_id : localStorage.getItem("admin_id"),
				//theme_id : formPayload.c_theme_id,
				title    		: formPayload.cloneTitle ? formPayload.cloneTitle : formPayload.title,
				line_height    	: formPayload.line_height,
				st_aisidebar_width: formPayload.st_aisidebar_width,
				st_aisidebar_collapsed_width: formPayload.st_aisidebar_collapsed_width,
				st_aisidebar_icon_width: formPayload.st_aisidebar_icon_width,
				pluginRadius    : formPayload.pluginRadius,
				dropdownRadius  : formPayload.dropdownRadius,
				inputRadius    	: formPayload.inputRadius,
				textareaRadius  : formPayload.textareaRadius,
				listRowRadius  : formPayload.listRowRadius,
				dashboardGridRadius  : formPayload.dashboardGridRadius,
				dashboardListRadius  : formPayload.dashboardListRadius,
				imageSliderRadius  : formPayload.imageSliderRadius,
				formGroupRadius  : formPayload.formGroupRadius,
				fontDetails:JSON.stringify(formPayload.fontDetails),
				shadow: JSON.stringify(this.state.shadows),
				status       : status,
			};
			// Only add theme_id if editing
			if (this.state.formAction === "edit") {
				postObject.theme_id = formPayload.c_theme_id;

				this.setState({Loading:true});
			} else{
				this.setState({LoadingCloneBtn:true});
			}
			let formData = new FormData();
			
			for(let k in postObject) {
			formData.append(k, postObject[k]);
			}		       
			//var filesdata = this.state.font_file;
			
			// for (var i in filesdata) {
			//  formData.append('font_file[]',filesdata[i])
			// }			
			// Choose endpoint
			let endpoint = this.state.formAction === "clone" ? apiUrl + "thememanagement/add" : apiUrl + "thememanagement/edit";
			//axios.post(apiUrl+"thememanagement/edit",qs.stringify(postObject)).then(res => {
			//axios.post(apiUrl+"thememanagement/edit",formData ).then(res => {
			axios.post(endpoint,formData ).then(res => {
				if(res.data.status === "success"){
					this.setState({ Loading: false, LoadingCloneBtn: false });
					$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');

					scrollToTop();
							setTimeout(
							function() {
								$('.success_message').html('');
								this.props.navigate('/themes');
							}
							.bind(this),
							3000
							);
				} else {
					this.setState({ Loading: false, LoadingCloneBtn: false });
					$('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');

					scrollToTop();
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
				}
			});
		}
	}

	validateForm() {
		const {title, fontDetails, st_aisidebar_icon_width, st_aisidebar_collapsed_width, formAction, cloneTitle} = this.state;

		let errors = 0;

		if(formAction === "clone"){
			if (!cloneTitle) {
				errors++;
				$('.errorcloneTitle').html('<span class="errorspan">Please fill the field</span>');
			}else if(cloneTitle){
				$('.errorcloneTitle').html('');
			}
		}

		if (!title) {
			errors++;
			$('.errortitle').html('<span class="errorspan">Please fill the field</span>');
		}else if(title){
			$('.errortitle').html('');
		}

		// Font details validation
		fontDetails.forEach((font, idx) => {
			// Reset previous errors
			$(`.errorfile${idx}`).html('');
			$(`.fontVariantError${idx}`).html('');
			$(`.fontFamilyError${idx}`).html('');
			$(`.fontSizeError${idx}`).html('');
			$(`.letterSpacingError${idx}`).html('');
			$(`.topSpaceError${idx}`).html('');
			$(`.bottomSpaceError${idx}`).html('');
			$(`.radiusError${idx}`).html('');		

			if (!font.font_id || font.font_id === "") {
				errors++;
				$(`.fontFamilyError${idx}`).html('<span class="errorspan">Select a font family</span>');
			}
			if (!font.fontWeight || font.fontWeight === "") {
				errors++;
				$(`.fontVariantError${idx}`).html('<span class="errorspan">Select a font variant</span>');
			}
			if (!font.fontSize || isNaN(font.fontSize)) {
				errors++;
				$(`.fontSizeError${idx}`).html('<span class="errorspan">Enter valid font size</span>');
			}
			if (font.letterSpacing === "" || isNaN(font.letterSpacing)) {
				errors++;
				$(`.letterSpacingError${idx}`).html('<span class="errorspan">Enter valid letter spacing</span>');
			}			

			if (["smallbutton", "largebutton", "pluginOpenButton"].includes(font.FontType)) {
				if (!font.topSpace || isNaN(font.topSpace)) {
					errors++;
					$(`.topSpaceError${idx}`).html('<span class="errorspan">Enter valid top space</span>');
				}
				if (!font.bottomSpace || isNaN(font.bottomSpace)) {
					errors++;
					$(`.bottomSpaceError${idx}`).html('<span class="errorspan">Enter valid bottom space</span>');
				}
				if (!font.radius || isNaN(font.radius)) {
					errors++;
					$(`.radiusError${idx}`).html('<span class="errorspan">Enter valid radius</span>');
				}
			}
		});

	

		if(errors>0) {
			setTimeout(function () {
				scrollToTopValidate();
			}, 100);
			return false;
		}
		else {
			return true;
		}
    }

	/**Shadow start */
		handleSubmit = () => {
			const popup = document.querySelector(".shadow-input-popup-action");
			if (popup) {
				popup.classList.remove("show");
			}
		};
	
		confirmPopup = (type) => {
			this.setState({ activeShadowType: type });
			$(".shadow-input-popup-action").addClass("show");
		};
		handleShadowChange = (value) => {
			this.setState((prevState) => ({
			shadows: {
				...prevState.shadows,
				[this.state.activeShadowType]: value,
			},
			}));
		};
	
		handleCancel = () => {
			const popup = document.querySelector(".shadow-input-popup-action");
			if (popup) {
				popup.classList.remove("show");
			}
		};
	
		labelFor = (key) => {
			const labels = {
				shadowPluginOpenButton: "Open Button Shadow",
				shadowPluginOpenButtonInset: "Open Button Inset Shadow",
				largeButton: "Button Shadow",
				shadowButtonInset: "Button Inset Shadow",
				shadowDropdownMenu: "Dropdown Shadow (Bell notification, Group menu in listing screen)",
				shadowDropdownMenuInset: "Dropdown Inset Shadow (Bell notification, Group menu in listing screen)",
				dashboardShadowGrid: "Dashboard Grid Shadow",
				shadowDashboardGridInset: "Dashboard Grid Inset Shadow",
				dashboardShadowList: "Dashboard List Shadow",
				shadowDashboardListInset: "Dashboard List Inset Shadow",
				shadowAISidebar: "AI Sidebar Shadow",
				shadowAISidebarInset: "AI Sidebar Inset Shadow",
				shadowTopPopup: "Top Popup Shadow",
				shadowTopPopupInset: "Top Popup Inset Shadow",
				shadowFormGroup: "Form Group Shadow",
				shadowFormGroupInset: "Form Group Inset Shadow",
				shadowLeftSidebar: "Left Sidebar Shadow (Side menu)",
				shadowLeftSidebarInset: "Left Sidebar Inset Shadow (Side menu)",
				shadowRightSidebar: "Right Sidebar Shadow (Chat window)",
				shadowRightSidebarInset: "Right Sidebar Inset Shadow (Chat window)",
				shadowSearchDropdown: "Search Dropdown Shadow",
				shadowSearchDropdownInset: "Search Dropdown Inset Shadow",
				shadowListRow: "List Shadow",
				shadowTableRow: "Table Shadow",
				shadowPluginInsetLeft: 'Plugin Inside Left Shadow',
				shadowPluginInsetRight: 'Plugin Inside Right Shadow',
				shadowPluginInsetTop: 'Plugin Inside Top Shadow',
				shadowPluginInsetBottom: 'Plugin Inside Bottom Shadow',

				shadowInput: "Input Box Shadow",
				shadowText: "Text Shadow (Result)",
				
				pluginShadow: "Plugin Shadow",
				textarea: "Textarea Shadow (Invite friend page textarea)",

				//sideMenu: "Sidemenu Shadow",
				//shortcutMenu: "Shortcut Menu Shadow (Shotcut menu, AI screen textarea)",
				//shadowPluginInset: "Plugin Inset Shadow",
				shadowMainAITextarea: "AI Screen Textarea Shadow",
			};
			return labels[key] || key;
		};
	
		handleInputChangeShadows = (type, value) => {
			this.setState((prevState) => ({
			shadows: {
				...prevState.shadows,
				[type]: value,
			},
			}));
		};
		/**Shadow end */
	
		/**Font management start */
		handleFileChangeVarients = async (e, idx, fontLabel, fontValue) => {
			let font_file = `font_file${idx}`;
			let fontDetails = [...this.state.fontDetails];

			fontDetails[idx] = {
			...fontDetails[idx],
			fontWeight: e.target.value,
			};
			fontDetails[e.target.dataset.id]["varient_id"] = idx;
			fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
			let selectedFont = e.target.name;
			this.setState({ fontDetails }, () => {
			console.log(this.state.fontDetails, "Updated fontDetails");
			});
		};
		addMoreFunc = (e) => {	

			// Radius images
			const insidefontManagementImages = {
				Primary: [
					{
						title: 'Primary',
						src: assetUrl + "theme_notes/font/primary.png",
					},
				],
				Menu_Logo: [
					{
						title: 'Menu Logo',
						src: assetUrl + "theme_notes/radius/plugin-radius.png",
					},
				],
				Main_Tab: [
					{
						title: 'Main Tab',
						src: assetUrl + "theme_notes/radius/plugin-radius.png", // Missing
					},
				],
				Side_Menu: [
					{
						title: 'Side Menu',
						src: assetUrl + "theme_notes/font/side-menu.png",
					},
				],
				Title: [
					{
						title: 'Title',
						src: assetUrl + "theme_notes/font/header-title.png",
					},
				],
				Sub_Title: [
					{
						title: 'Sub Title',
						src: assetUrl + "theme_notes/font/list-title.png", // Missing
					},
				],
				List_Font: [
					{
						title: 'List Font',
						src: assetUrl + "theme_notes/font/list-font.png",
					},
				],
				List_Title_Font: [
					{
						title: 'List Title Font',
						src: assetUrl + "theme_notes/font/list-title.png",
					},
				],
				List_Serial_No_Font: [
					{
						title: 'List Serial No Font',
						src: assetUrl + "theme_notes/font/list-serial-no.png",
					},
				],
				Dashboard_List: [
					{
						title: 'Dashboard List',
						src: assetUrl + "theme_notes/font/dashboard-list-name.png",
					},
				],
				Dashboard_List_Count: [
					{
						title: 'Dashboard List Count',
						src: assetUrl + "theme_notes/font/dashboard-list-count.png",
					},
				],
				Large_Button: [
					{
						title: 'Large Button',
						src: assetUrl + "theme_notes/font/large-button.png",
					},
				],
				Small_Button: [
					{
						title: 'Small Button',
						src: assetUrl + "theme_notes/radius/plugin-radius.png", // Missing
					},
				],
				Plugin_Open_Button: [
					{
						title: 'Plugin Open Button',
						src: assetUrl + "theme_notes/font/plugin-open-button.png",
					},
				],
				AI_Chat_Summary_Title: [
					{
						title: 'AI Chat Summary Title',
						src: assetUrl + "theme_notes/font/ai-sidebar-chat-summary-title.png",
					},
				],
				AI_Chat_Summary: [
					{
						title: 'AI Chat Summary',
						src: assetUrl + "theme_notes/font/ai-sidebar-chat-summary.png",
					},
				],
				AI_Profile_Name: [
					{
						title: 'AI Profile Name',
						src: assetUrl + "theme_notes/font/ai-profile-name.png",
					},
				],
				Form_Label: [
					{
						title: 'Form Label',
						src: assetUrl + "theme_notes/font/form-label.png",
					},
				],
				Form_Input_Placeholder: [
					{
						title: 'Form Input Placeholder',
						src: assetUrl + "theme_notes/font/form-input-placeholder.png",
					},
				],
				Form_Input_Value: [
					{
						title: 'Form Input Value',
						src: assetUrl + "theme_notes/font/form-input-value.png",
					},
				],
				Form_Label_Focused: [
					{
						title: 'Form Label Focused',
						src: assetUrl + "theme_notes/font/form-input-value.png",
					},
				],
				Form_Input: [
					{
						title: 'Form Input Value',
						src: assetUrl + "theme_notes/font/form-input-value.png",
					},
				],
			};

			return this.state.fontDetails.map((val, idx) => {
				const formattedName = val.listName.replace(/\s+/g, "_");
				let FontType = `FontType${idx}`,
				fontWeight = `fontWeight${idx}`,
				FontSize = `FontSize${idx}`,
				letterSpacing = `letterSpacing${idx}`,
				lineHeight = `lineHeight${idx}`,
				TopSpace = `TopSpace${idx}`,
				BottomSpace = `BottomSpace${idx}`,
				radius = `radius${idx}`,
				errorfile = `errorfile${idx}`;
				return ( <>
				<div className="form-row mb-0" key={val.index}>
						<div className='form-left'>			
						<div className="form-group"  >					
							<h4 className="fs-5" onClick={() =>
								this.handleSettingsNotesOpenPopup(formattedName)
							}>
								{/* Apply font : */}
	
								{/* Font Apply to {this.Capitalize(val.FontType)} */}
								{(val.listName)} :{" "}
								{Object.keys(insidefontManagementImages).includes(formattedName) && (
									<i
										className="fa fa-info-circle ms-2 fs-6 cursor-pointer"
									></i>
								)}
							</h4>
						</div>
						</div>
					</div>
					<div className="form-row mb-5" key={val.index}>	
						{this.varientField(val.font_id, val.fontFamily, val.FontType,idx,val,val.index)}
					</div>
				</>
				);
			});
		}
	
		// varientField = (FontId, FontFamily, FontType,idx,val,selIndex)=>{
		// 	console.log(FontType);
			
		// 	//console.log('done');
		// 	const fontArray = this.state.fonttype.map ((fonttype, index) => ({
		// 	id: index,
		// 	name: fonttype,
		// 	}));
		// 	// Dynamically create select list
		// 	let fonts = [];
		// 	fontArray.map(item =>
		// 		fonts.push({ label: item.name.label, value: item.name.value , fontStyles: item.name.tf_fontStyles, typeIs: item.name.tf_font_type }),
		// 	);
	
		// 	//console.log(fontArray);
	
		// 	let fontWeight = `fontWeight${idx}`,
		// 	FontSize = `FontSize${idx}`,
		// 	FontIndId = `FontId${idx}`,
		// 	letterSpacing = `letterSpacing${idx}`,
		// 	lineHeight = `lineHeight${idx}`,
		// 	TopSpace = `TopSpace${idx}`,
		// 	BottomSpace = `BottomSpace${idx}`,
		// 	radius = `radius${idx}`,
		// 	fontVariantError = `fontVariantError${idx}`,
		// 	fontFamilyError = `fontFamilyError${idx}`,
		// 	fontSizeError = `fontSizeError${idx}`,
		// 	letterSpacingError = `letterSpacingError${idx}`,
		// 	topSpaceError = `topSpaceError${idx}`,
		// 	bottomSpaceError = `bottomSpaceError${idx}`,
		// 	radiusError = `radiusError${idx}`,
		// 	errorfile = `errorfile${idx}`
		// 	//if(FontType !=='smallButton' && FontType!=='largeButton'){
		// 	return(
		// 		<>
		// 		<div className="form-left">
		// 			<div className="form-group">
		// 				<label>Font Family  :</label>
		// 				<div>																						
		// 					<select name="font_id" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx,selIndex)}>
	
		// 					<option value="" className="fontFamilyId" > Select Font</option>						
		// 					{fonts.map((option) => (
		// 					<option key={option.value} value={option.value}  selected={val.font_id==option.value?true:false}>
		// 						{option.label}
		// 					</option>
		// 					))}
		// 					</select>	
		// 					<div className={fontFamilyError}></div> 						
		// 				</div>
		// 			</div>	
		// 		</div>
		// 		<div className="form-right">
		// 			<div className="form-group">
		// 				<label>Font Variant :</label>
		// 				<div>
		// 					 <select name="fontWeight" className="form-control" id={FontType} data-id={idx} onChange={(e) => this.handleFileChange(e, idx)}>
	
		// 					<option value="" className="fontVarientName" > Select Variant</option>
		// 					<option value="200" className="fontVarientName" selected={val.fontWeight=='200'?true:false} > Extra Light200</option>
		// 					<option value="300" className="fontVarientName" selected={val.fontWeight=='300'?true:false}> Light 300</option>
		// 					<option value="400" className="fontVarientName" selected={val.fontWeight=='400'?true:false}> Regular 400</option>
		// 					<option value="500" className="fontVarientName" selected={val.fontWeight=='500'?true:false}> Medium 500</option>
		// 					<option value="600" className="fontVarientName" selected={val.fontWeight=='600'?true:false} > Semi Bold 600</option>
		// 					<option value="700" className="fontVarientName" selected={val.fontWeight=='700'?true:false}> Bold 700</option>
		// 					<option value="800" className="fontVarientName" selected={val.fontWeight=='800'?true:false}> Extra Bold 800</option>
		// 					<option value="900" className="fontVarientName" selected={val.fontWeight=='900'?true:false}>Black 900</option>
											
		// 					</select>	 
	
	
																
		// 					<div className={fontVariantError}></div> 
		// 				</div>
		// 			</div>	
		// 		</div>	
		// 		<div className="form-left">
		// 			<div className="form-group">
		// 				<label>Font Size  :</label>
		// 				<div>
		// 					<input type="text" name="fontSize" 
		// 					onChange={(e) => this.handleFileChange(e, idx)} 
		// 					//onChange={this.onFileChange}
		// 					value={val.fontSize}
	
		// 					data-id={idx}
		// 					id={FontSize}    /> 
										
		// 					<div className={fontSizeError}></div> 
		// 				</div>
		// 			</div>	
		// 		</div>
		// 		<div className="form-right">
		// 			<div className="form-group">
		// 				<label>Letter Spacing  :</label>
		// 				<div>
		// 					<input type="text" name="letterSpacing" 
		// 					onChange={(e) => this.handleFileChange(e, idx)} 
		// 					//onChange={this.onFileChange}
		// 					value={val.letterSpacing}
	
		// 					data-id={idx}
		// 					id={letterSpacing}    /> 
										
		// 					<div className={letterSpacingError}></div> 
		// 				</div>
		// 			</div>	
		// 		</div>
		// 		{
		// 		(FontType =='smallbutton' || FontType=='largebutton' || FontType == 'pluginOpenButton') ?
		// 			<>
		// 			<div className="form-left">
		// 				<div className="form-group">
		// 					<label>Top Space :</label>
		// 					<div>
		// 						<input type="text" name="topSpace" 
		// 						onChange={(e) => this.handleFileChange(e, idx)} 
		// 						value={val.topSpace}
		// 						data-id={idx}
		// 						id={TopSpace}    /> 
											
		// 						<div className={topSpaceError}></div> 
		// 					</div>
		// 				</div>	
		// 			</div>
					
		// 			<div className="form-right">
		// 				<div className="form-group">
		// 					<label>Bottom Space :</label>
		// 					<div>
		// 						<input type="text" name="bottomSpace" 
		// 						onChange={(e) => this.handleFileChange(e, idx)} 
		// 						value={val.bottomSpace}
		// 						data-id={idx}
		// 						id={BottomSpace}    /> 									
		// 						<div className={bottomSpaceError}></div> 
		// 					</div>
		// 				</div>	
		// 			</div>					
		// 			</>
		// 		: ''
		// 		}
		// 		{
		// 		(FontType =='smallbutton' || FontType=='largebutton' || FontType == 'pluginOpenButton') ?
		// 			<>					
		// 			<div className="form-left">
		// 				<div className="form-group">
		// 					<label>Radius :</label>
		// 					<div>
		// 						<input type="text" name="radius" 
		// 						onChange={(e) => this.handleFileChange(e, idx)} 
		// 						value={val.radius}
		// 						data-id={idx}
		// 						id={radius}    /> 	
		// 						<div className={radiusError}></div> 
		// 					</div>
		// 				</div>	
		// 			</div>
		// 			</>
		// 		: ''
		// 		}
		// 	</>);
		// }
		varientField = (FontId, FontFamily, FontType, idx, val, selIndex) => {
			const fontArray = this.state.fonttype.map((fonttype, index) => ({
				id: index,
				name: fonttype,
			}));

			console.log(fontArray, "this is for font array");
			// Dynamically create select list
			let fonts = [];
			fontArray.map((item) =>
			fonts.push({
				label: item.name.label,
				value: item.name.value,
				fontStyles: item.name.font_style,
				typeIs: item.name.type,
				type: item.name.type,
			})
			);

			let fontWeight = `fontWeight${idx}`,
			FontSize = `FontSize${idx}`,
			FontIndId = `FontId${idx}`,
			letterSpacing = `letterSpacing${idx}`,
			lineHeight = `lineHeight${idx}`,
			TopSpace = `TopSpace${idx}`,
			BottomSpace = `BottomSpace${idx}`,
			radius = `radius${idx}`,
			fontFamilyError = `fontFamilyError${idx}`,
			fontVariantError = `fontVariantError${idx}`,
			fontSizeError = `fontSizeError${idx}`,
			letterSpacingError = `letterSpacingError${idx}`,
			topSpaceError = `topSpaceError${idx}`,
			bottomSpaceError = `bottomSpaceError${idx}`,
			radiusError = `radiusError${idx}`
			;
			//if(FontType !=='smallButton' && FontType!=='largeButton'){
			return (
			<>
				<div className="form-left">
				<div className="form-group">
					<label>Font Family :</label>
					<div>
					<select
						name="font_id"
						className="form-control"
						id={FontType}
						data-id={idx}
						value={val.font_id?.toString() || ""}
						onChange={(e) => {
						const selectedValue = e.target.value;
						const selectedOption = fonts.find(
							(option) => option.value === selectedValue
						);
						this.handleFileChange(
							e,
							idx,
							selectedOption?.label,
							selectedOption?.value
						);
						}}
					>
						<option value="">Select Font</option>

						<optgroup label="System Fonts">
						{fonts
							.filter((f) => f.type === "system_font")
							.map((option) => (
							<option key={option.value} value={option.value}>
								{option.label}
							</option>
							))}
						</optgroup>
						<optgroup label="Google Fonts">
						{fonts
							.filter((f) => f.type === "google_font")
							.map((option) => (
							<option key={option.value} value={option.value}>
								{option.label}
							</option>
							))}
						</optgroup>
						{console.log(fonts, "this is for fonts label")}
						<optgroup label="Custom Fonts">
						{fonts
							.filter((f) => f.type === "normal_font")
							.map((option) => (
							<option key={option.value} value={option.value}>
								{option.label}
							</option>
							))}
						</optgroup>
					</select>
					<div className={fontFamilyError}></div>
					</div>
				</div>
				</div>
				<div className="form-right">
				<div className="form-group">
					<label>Font Variant :</label>
					<div>
					<select
						name="fontWeight"
						className="form-control"
						id={FontType}
						data-id={idx}
						onChange={(e) => this.handleFileChangeVarients(e, idx)}
					>
						<option value="" className="fontVarientName">
						Select Variant
						</option>
						{console.log(this.state.fontDetails, "this is fontsdetails")}
						{this.state.fontDetails[idx]?.variants?.map((variant) => (
						<option
							key={variant.value}
							value={variant.value || val.fontWeight}
							selected={val.fontWeight == variant.value ? true : false}
						>
							{variant.label} {variant.value}
						</option>
						))}
					</select>

					<div className={fontVariantError}></div>
					</div>
				</div>
				</div>

				<div className="form-left">
				<div className="form-group">
					<label>Font Size :</label>
					<div>
					<input
						type="text"
						name="fontSize"
						onChange={(e) => this.handleFileChange(e, idx)}
						//onChange={this.onFileChange}
						value={val.fontSize}
						data-id={idx}
						id={FontSize}
					/>

					<div className={fontSizeError}></div>
					</div>
				</div>
				</div>
				<div className="form-right">
				<div className="form-group">
					<label>Letter Spacing :</label>
					<div>
					<input
						type="text"
						name="letterSpacing"
						onChange={(e) => this.handleFileChange(e, idx)}
						//onChange={this.onFileChange}
						value={val.letterSpacing}
						data-id={idx}
						id={letterSpacing}
					/>

					<div className={letterSpacingError}></div>
					</div>
				</div>
				</div>
				{console.log(FontType, "thi is fonttype")}
				{FontType == "smallbutton" ||
				FontType == "largebutton" ||
				FontType == "pluginOpenButton" ? (
				<>
					<div className="form-left">
					<div className="form-group">
						<label>Top Space :</label>
						<div>
						<input
							type="text"
							name="topSpace"
							onChange={(e) => this.handleFileChange(e, idx)}
							value={val.topSpace}
							data-id={idx}
							id={TopSpace}
						/>

						<div className={topSpaceError}></div>
						</div>
					</div>
					</div>
					<div className="form-right">
					<div className="form-group">
						<label>Bottom Space :</label>
						<div>
						<input
							type="text"
							name="bottomSpace"
							onChange={(e) => this.handleFileChange(e, idx)}
							value={val.bottomSpace}
							data-id={idx}
							id={BottomSpace}
						/>
						<div className={bottomSpaceError}></div>
						</div>
					</div>
					</div>
					<div className="form-left">
					<div className="form-group">
						<label>Radius :</label>
						<div>
						<input
							type="text"
							name="radius"
							onChange={(e) => this.handleFileChange(e, idx)}
							value={val.radius}
							data-id={idx}
							id={radius}
						/>

						<div className={radiusError}></div>
						</div>
					</div>
					</div>
				</>
				) : (
				""
				)}
			</>
			);
		};
	
		// handleFileChange = (e, idx) => {
		// 	let	font_file = `font_file${idx}`;
		// 	let fontDetails = [...this.state.fontDetails];
		// 	fontDetails[e.target.dataset.id]['varient_id'] = idx;	
		// 	fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
		// 	this.setState({
		// 		fontDetails: 			  
		// 		fontDetails
		// 	});
	
		// }; 
		handleFileChange = async (e, idx, fontLabel, fontValue) => {
			let font_file = `font_file${idx}`;
			let fontDetails = [...this.state.fontDetails];
			fontDetails[e.target.dataset.id]["varient_id"] = idx;
			fontDetails[e.target.dataset.id][e.target.name] = e.target.value;
			let selectedFont = e.target.name;
			if (fontValue) {
			try {
				const response = await axios.get(`${apiUrl}font/getvarientlistdetail`, {
				params: {
					id: fontValue,
					name: fontLabel,
				},
				});
				if (response.data.variants) {
				fontDetails[idx] = {
					...fontDetails[idx],
					variants: response.data.variants,
				};
				console.log(response.data.variants, "this is fortvarientrecords");
				}
			} catch (error) {
				console.error("Error fetching font variants:", error);
			}
			}
	
			this.setState({ fontDetails }, () => {
			console.log(this.state.fontDetails, "Updated fontDetails");
			});
		};
		/**Font management end */

		/**Clone theme start */
		confirmThemePopup = (title) => {					 	
			//this.setState({ formAction: "clone", cloneTitle: title + " Copy", showClonePopup: true });
			this.setState({ formAction: "clone", cloneTitle: "", showClonePopup: true });
		};
		/**Clone theme end */
		handleSettingsNotesOpenPopup = (label) => {			
			this.setState({ settingsNotesPopup: true, infoSliderName : label });
		}
		handleSettingsNotesClosePopup = () => {
			this.setState({ settingsNotesPopup: false, infoSliderName : '' });
		}
	
	
  
  	render() {
  	const {selectedOption} = this.state;
	const settings = {
      dots: false,
      infinite: false,   // disable infinite loop
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

	/**Shadow images start */
	const shadowImages = {
		shadowPluginOpenButton: [
			{
			title: "Plugin Open Button Shadow",
			src: assetUrl + "theme_notes/shadow/plugin-open-button-shadow.png",
			}
		],
		shadowPluginOpenButtonInset: [
			{
			title: "Plugin Open Inside Button Shadow",
			src: assetUrl + "theme_notes/shadow/plugin-open-button-inner-shadow.png",
			}
		],
		largeButton: [
			{
			title: "Button Shadow",
			src: assetUrl + "theme_notes/shadow/buttons-shadow.png",
			}
		],
		shadowButtonInset: [
			{
			title: "Button Inside Shadow",
			src: assetUrl + "theme_notes/shadow/buttons-inner-shadow.png",
			}
		],
		dashboardShadowGrid: [
			{
			title: "Dashboard Grid Shadow",
			src: assetUrl + "theme_notes/shadow/dashboard-grid-shadow.png",
			}
		],
		shadowDashboardGridInset: [
			{
			title: "Dashboard Grid Inside Shadow",
			src: assetUrl + "theme_notes/shadow/dashboard-grid-inner-shadow.png",
			}
		],
		dashboardShadowList: [
			{
			title: "Dashboard List Shadow",
			src: assetUrl + "theme_notes/shadow/dashboard-list-shadow.png",
			},
		],
		shadowDashboardListInset: [
			{
			title: "Dashboard List Inside Shadow",
			src: assetUrl + "theme_notes/shadow/dashboard-list-inner-shadow.png",
			}
		],			
		shadowDropdownMenu: [
			{
			title: "Bell notification dropdown shadow",
			src: assetUrl + "theme_notes/shadow/bell-notification-dropdown-shadow.png",
			},			
			{
			title: "Group menu in listing screen shadow",
			src: assetUrl + "theme_notes/shadow/group-menu-listing-screen-shadow.png",
			},						
		],
		shadowDropdownMenuInset: [
			{
			title: "Bell notification dropdown inside shadow",
			src: assetUrl + "theme_notes/shadow/bell-notification-dropdown-inner-shadow.png",
			},				
			{
			title: "Group menu in listing screen inside shadow",
			src: assetUrl + "theme_notes/shadow/group-menu-listing-screen-inner-shadow.png",
			},
		],
		shadowSearchDropdown: [
			{
			title: "Search dropdown shadow",
			src: assetUrl + "theme_notes/shadow/search-dropdown-shadow.png",
			},	
		],
		shadowSearchDropdownInset: [
			{
			title: "Search dropdown inside shadow",
			src: assetUrl + "theme_notes/shadow/search-dropdown-inner-shadow.png",
			},
		],		
		shadowTopPopup: [
			{
			title: "Add Card Popup Shadow",
			src: assetUrl + "theme_notes/shadow/top-popup-shadow.png",
			}
		],
		shadowTopPopupInset: [
			{
			title: "Add Card Popup Inside Shadow",
			src: assetUrl + "theme_notes/shadow/top-popup-inner-shadow.png",
			}
		],
		shadowLeftSidebar: [
			{
			title: "Side Menu Shadow",
			src: assetUrl + "theme_notes/shadow/left-sidebar-shadow.png",
			}
		],
		shadowLeftSidebarInset: [
			{
			title: "Side Menu Inside Shadow",
			src: assetUrl + "theme_notes/shadow/left-sidebar-inner-shadow.png",
			},
			
		],	
		shadowRightSidebar: [
			{
			title: "Chat Window Shadow",
			src: assetUrl + "theme_notes/shadow/chat-window-shadow.png",
			},			
		],
		shadowRightSidebarInset: [
			{
			title: "Chat Window Inside Shadow",
			src: assetUrl + "theme_notes/shadow/chat-window-inner-shadow.png",
			},			
		],	
		shadowAISidebar: [
			{
			title: "AI Screen Sidebar Shadow",
			src: assetUrl + "theme_notes/shadow/ai-sidebar-shadow.png",
			}
		],
		shadowAISidebarInset: [
			{
			title: "AI Screen Sidebar Inside Shadow",
			src: assetUrl + "theme_notes/shadow/ai-sidebar-inner-shadow.png",
			}
		],
		shadowMainAITextarea: [
			{
			title: "AI Screen Textarea Shadow",
			src: assetUrl + "theme_notes/shadow/ai-screen-textarea-shadow.png",
			}
		],					
		shadowInput: [
			{
			title: "Input Box Shadow",
			src: assetUrl + "theme_notes/shadow/input-box-shadow.png",
			}
		],
		shadowText: [
			{
			title: "Text Shadow (Result text)",
			src: assetUrl + "theme_notes/shadow/text-shadow.png",
			}
		],
		shadowListRow: [
			{
			title: "List Shadow",
			src: assetUrl + "theme_notes/shadow/list-shadow.png",
			}
		],
		shadowTableRow: [
			{
			title: "Table Shadow",
			src: assetUrl + "theme_notes/shadow/table-shadow.png",
			}
		],
		pluginShadow: [
			{
			title: "Plugin Shadow",
			src: assetUrl + "theme_notes/shadow/plugin-shadow.png",
			}
		],
		textarea: [
			{
			title: "Textarea Shadow",
			src: assetUrl + "theme_notes/shadow/textarea-shadow.png",
			}
		],
		shadowPluginInsetLeft: [
			{
			title: "Plugin Inside Left Shadow",
			src: assetUrl + "theme_notes/shadow/plugin-left-inner-shadow.png",
			}
		],
		shadowPluginInsetRight: [
			{
			title: "Plugin Inside Right Shadow",
			src: assetUrl + "theme_notes/shadow/plugin-right-inner-shadow.png",
			}
		],
		shadowPluginInsetTop: [
			{
			title: "Plugin Inside Top Shadow",
			src: assetUrl + "theme_notes/shadow/plugin-top-inner-shadow.png",
			}
		],
		shadowPluginInsetBottom: [
			{
			title: "Plugin Inside Bottom Shadow",
			src: assetUrl + "theme_notes/shadow/plugin-bottom-inner-shadow.png",
			}
		],
	};
	/**Shadow images end */

	/**Radius images start */
	const radiusImages = {
		pluginRadius: [
			{
			title: "Plugin Radius",
			src: assetUrl + "theme_notes/radius/plugin-radius.png",
			},
		],
		// dropdownRadius: [
		// 	{
		// 	title: "Bell notification radius",
		// 	src: assetUrl + "theme_notes/radius/dropdown-radius.png",
		// 	},
		// 	{
		// 	title: "Group menu in listing screen radius",
		// 	src: assetUrl + "theme_notes/radius/dropdown-radius.png",
		// 	},			

		// ],
		inputRadius: [
			{
			title: "Input Box Radius",
			src: assetUrl + "theme_notes/radius/input-box-radius.png",
			},
		],
		textareaRadius: [
			{
			title: "Textarea Radius",
			src: assetUrl + "theme_notes/radius/textarea-radius.png",
			},
		],
		dashboardGridRadius: [
			{
			title: "Dashboard Grid Radius",
			src: assetUrl + "theme_notes/radius/dashboard-grid-radius.png",
			},
		],
		dashboardListRadius: [
			{
			title: "Dashboard List Radius",
			src: assetUrl + "theme_notes/radius/dashboard-list-radius.png",
			},
		],
		listRowRadius: [
			{
			title: "List Row Radius",
			src: assetUrl + "theme_notes/radius/list-row-radius.png",
			},
		],
		listRowRadius: [
			{
			title: "Form Group Radius",
			src: assetUrl + "theme_notes/radius/form-group-radius.png",
			},
		],
		// imageSliderRadius: [
		// 	{
		// 	title: "Image Slider Radius",
		// 	src: assetUrl + "theme_notes/radius/ai-textarea-radius.png",
		// 	},
		// ],
	};
	/**Radius images end */
	/**AI sidebar images start */
	const aiSidebarImages = {
		st_aisidebar_width: [
			{
			title: "AI Sidebar Expanded Size",
			src: assetUrl + "theme_notes/ai_sidebar/sidebar-expended- size.png",
			},
		],
		st_aisidebar_collapsed_width: [
			{
			title: "AI Sidebar Collapsed Size",
			src: assetUrl + "theme_notes/ai_sidebar/sidebar-collapsed-size.png",
			},
		],
		st_aisidebar_icon_width: [
			{
			title: "AI Sidebar Icon Size",
			src: assetUrl + "theme_notes/ai_sidebar/sidebar-icon-size.png",
			},
		],		
	};

	/**AI sidebar images end */

	/** Line height images start */
	const fontManagementImages = {
		line_height: [
			{
			title: "Line Height",
			src: assetUrl + "theme_notes/font/line-height.png",
			},
		],
	};
	/** Line height images end */

	/**Font management images start */
	const insidefontManagementImages = {
		Primary: [
			{
				title: 'Primary',
				src: assetUrl + "theme_notes/font/primary.png",
			},
		],
		Menu_Logo: [
			{
				title: 'Menu Logo',
				src: assetUrl + "theme_notes/radius/plugin-radius.png",
			},
		],
		Main_Tab: [
			{
				title: 'Main Tab',
				src: assetUrl + "theme_notes/radius/plugin-radius.png", // Missing
			},
		],
		Side_Menu: [
			{
				title: 'Side Menu',
				src: assetUrl + "theme_notes/font/side-menu.png",
			},
		],
		Title: [
			{
				title: 'Title',
				src: assetUrl + "theme_notes/font/header-title.png",
			},
		],
		Sub_Title: [
			{
				title: 'Sub Title',
				src: assetUrl + "theme_notes/font/list-title.png", // Missing
			},
		],
		List_Font: [
			{
				title: 'List Font',
				src: assetUrl + "theme_notes/font/list-font.png",
			},
		],
		List_Title_Font: [
			{
				title: 'List Title Font',
				src: assetUrl + "theme_notes/font/list-title.png",
			},
		],
		List_Serial_No_Font: [
			{
				title: 'List Serial No Font',
				src: assetUrl + "theme_notes/font/list-serial-no.png",
			},
		],
		Dashboard_List: [
			{
				title: 'Dashboard List',
				src: assetUrl + "theme_notes/font/dashboard-list-name.png",
			},
		],
		Dashboard_List_Count: [
			{
				title: 'Dashboard List Count',
				src: assetUrl + "theme_notes/font/dashboard-list-count.png",
			},
		],
		Large_Button: [
			{
				title: 'Large Button',
				src: assetUrl + "theme_notes/font/large-button.png",
			},
		],
		Small_Button: [
			{
				title: 'Small Button',
				src: assetUrl + "theme_notes/radius/plugin-radius.png", // Missing
			},
		],
		Plugin_Open_Button: [
			{
				title: 'Plugin Open Button',
				src: assetUrl + "theme_notes/font/plugin-open-button.png",
			},
		],
		AI_Chat_Summary_Title: [
			{
				title: 'AI Chat Summary Title',
				src: assetUrl + "theme_notes/font/ai-sidebar-chat-summary-title.png",
			},
		],
		AI_Chat_Summary: [
			{
				title: 'AI Chat Summary',
				src: assetUrl + "theme_notes/font/ai-sidebar-chat-summary.png",
			},
		],
		AI_Profile_Name: [
			{
				title: 'AI Profile Name',
				src: assetUrl + "theme_notes/font/ai-profile-name.png",
			},
		],
		Form_Label: [
			{
				title: 'Form Label',
				src: assetUrl + "theme_notes/font/form-label.png",
			},
		],
		Form_Input_Placeholder: [
			{
				title: 'Form Input Placeholder',
				src: assetUrl + "theme_notes/font/form-input-placeholder.png",
			},
		],
		Form_Input_Value: [
			{
				title: 'Form Input Value',
				src: assetUrl + "theme_notes/font/form-input-value.png",
			},
		],
		Form_Label_Focused: [
			{
				title: 'Form Label Focused',
				src: assetUrl + "theme_notes/font/form-input-value.png",
			},
		],
		Form_Input: [
			{
				title: 'Form Input Value',
				src: assetUrl + "theme_notes/font/form-input-value.png",
			},
		],
	};
	/** Font management images end */

    return (
    <div className="wrapper"> 		
		{this.state.showClonePopup && (
          <div className="popup-sec active">
            <div className='popup-sec-in h-auto'>
              <p>Enter a title for cloned theme:</p>
              <input
                type="text"
                value={this.state.cloneTitle}
				name='cloneTitle'
                //onChange={(e) => this.setState({ cloneTitle: e.target.value })}
                onChange={this.handleInputPopupChange}
                className="form-control"
              />
			  <div className="errorcloneTitle"></div>
              <div className="d-flex gap-4 justify-content-center mt-4">
                <a href="javascript://"
                  onClick={() => { this.handleFormSubmit(this); }}
                  className="btn">Clone</a>
                <a href="javascript://"
                  onClick={() => this.setState({ showClonePopup: false, cloneTitle: "", formAction: "edit" })}
                  className="btn">Cancel</a>
              </div>
            </div>
          </div>
        )}	
		<Header />
		<MenuSidebar currentpage="themes" />  
		<div className="content">	
			<div className="content-wrapper">
				<div className="content-wrapper-before"></div>
					<div className="form-wrapper leaa-admin-head card">
					<div className="success_message"></div>
					<div>
						<a className="btn" href="/themes">Back</a>
					</div>
					<div className="title">
						<h4>Edit Theme</h4>
					</div>
					<form className="login" id="login" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }}>
						
						<div className="form-row">
							<div className='form-left'>
								<div className="form-group">
									<label>Template Name<span class="required" style={{ color: "red" }} > * </span></label>
									<input type="text" name="title" onChange={this.handleInputChange} className="form-control" value={this.state.title} autoComplete="off" />
									<div className="errortitle"></div>
								</div>
							</div>
							<div className='form-right'>
								<div className="form-group">					
									<label>Status</label>
									<Select 
									value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
									options={lang.common.status_option} 
									onChange={this.handleChange}
									/>
								</div>
							</div>
						</div>

						<div className="title">
							<h4>Ai Sidebar Management</h4>
						</div> 		   
						<div className="form-row">
							<div className="form-left">
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "st_aisidebar_width")}
									>
										Sidebar Expanded size (px)<span class="required" style={{ color: "red" }} > * </span>:
										{Object.keys(aiSidebarImages).includes("st_aisidebar_width") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="st_aisidebar_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_width}/>
									<div className="errorsst_aisidebar_width"></div>
								</div>						
										
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "st_aisidebar_icon_width")}
									>
										Sidebar Icon Size (px)<span class="required" style={{ color: "red" }} > * </span>:
										{Object.keys(aiSidebarImages).includes("st_aisidebar_icon_width") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="st_aisidebar_icon_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_icon_width}/>
									<div className="errorsst_aisidebar_icon_width"></div>
								</div>			
							</div>	
							<div className="form-right">
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "st_aisidebar_collapsed_width")}
									>
										Sidebar Collapsed size (px)<span class="required" style={{ color: "red" }} > * </span>:
										{Object.keys(aiSidebarImages).includes("st_aisidebar_collapsed_width") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="st_aisidebar_collapsed_width" onChange={this.handleInputChange}  value={this.state.st_aisidebar_collapsed_width}/>
									<div className="errorsst_aisidebar_collapsed_width"></div>
								</div>	
																	
							</div>	
							
						</div>

						

						{/* Shadow Management Start */}
						<div className="title">
							<h4>Shadow Management</h4>
						</div>

						<div className="form-row">
							<div className="shadow-input-popup-action">
								<span
								className="shadow-input-close"
								onClick={this.handleCancel}
								>
								X
								</span>
								<div className="title">
									<h4 style={{ fontSize: "30px" }}>
										{this.labelFor(this.state.activeShadowType)}
									</h4>
								</div>
								<div className="shadow-picker-container d-flex w-100 justify-content-between">
									<ShadowPicker
										value={
										this.state.shadows[this.state.activeShadowType] ||
										""
										}
										onChange={(value) => this.handleShadowChange(value)}
										className="shadow-picker"
									/>

									<div
										className="shadow-box"
										style={{
										boxShadow:
											this.state.shadows[this.state.activeShadowType] ||
											"none",
										}}
									></div>
								</div>
								<div className="d-flex w-100 justify-content-end gap-2 mt-5">
									<button type="button" className="shadow-btn" onClick={this.handleSubmit}>
										Save
									</button>
								</div>
							</div>
						</div>

						<div className="form-row">
							{Object.entries(this.state.shadows).map(([key, value]) => (
								<div className="form-left" key={key}>
									<div className="form-group admin-panel-btn">
										<label
											className="cursor-pointer"
											onClick={this.handleSettingsNotesOpenPopup.bind(this, key)}
										>
											{this.labelFor(key)}: 
											{Object.keys(shadowImages).includes(key) && (<i className="fa fa-info-circle ms-2"></i>)}
										</label>
										<input
										value={value}
										type="text"
										autoComplete="off"
										className="form-control"
										style={{ width: "85%" }}
										onChange={(e) =>
											this.handleInputChangeShadows(key, e.target.value)
										}
										/>
										<button
										type="button"
										onClick={() => this.confirmPopup(key)}
										style={{
											color: "white",
											padding: "14px",
											minWidth: "47px",
											height: "48px",
											backgroundColor: "rgb(5, 31, 58)",
											borderRadius: "0px 5px 5px 0px",
										}}
										>
										<i>
											<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="#fff"
											viewBox="32 -0.03 543.87 512.03"
											>
											<path d="M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448L64 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"></path>
											</svg>
										</i>
										</button>
									</div>
								</div>
							))}
						</div>

						{/* Settings notes popup */}
						<div 
							className={`${this.state.settingsNotesPopup && 'active'} popup-sec`}						
						>
							<div className='popup-sec-in'>
								<span onClick={this.handleSettingsNotesClosePopup} className='popup-close position-absolute cursor-pointer'>X</span>															
								<Slider className="settings-notes-slider"
								key={this.state.settingsNotesPopup ? "open" : "closed"}
								{...settings}>
									{/* Shadow images */}
									{Object.keys(shadowImages).map((shadowKey) =>
										this.state.infoSliderName === shadowKey &&
										shadowImages[this.state.infoSliderName].map((img, i) => (
										<div key={`${shadowKey}-${i}`}>
											<h4 className='settings-notes-slide-title'>{img.title}</h4>
											<img src={img.src} alt={img.title} />
										</div>
										))
									)}

									{/* AI Sidebar Images */}
									{Object.keys(aiSidebarImages).map(
										(sidebarKey) =>
										this.state.infoSliderName === sidebarKey &&
										aiSidebarImages[sidebarKey].map((img, i) => (
											<div key={`${sidebarKey}-${i}`}>
											<h4 className="settings-notes-slide-title">{img.title}</h4>
											<img src={img.src} alt={img.title} />
											</div>
										))
									)}

									{/* Radius images */}
									{Object.keys(radiusImages).map((radiusKey) =>
										this.state.infoSliderName === radiusKey &&
										radiusImages[radiusKey].map((img, i) => (
										<div key={`${radiusKey}-${i}`}>
											<h4 className="settings-notes-slide-title">{img.title}</h4>
											<img src={img.src} alt={img.title} />
										</div>
										))
									)}

									{/* Font Management images */}
									{Object.keys(fontManagementImages).map((radiusKey) =>
										this.state.infoSliderName === radiusKey &&
										fontManagementImages[radiusKey].map((img, i) => (
										<div key={`${radiusKey}-${i}`}>
											<h4 className="settings-notes-slide-title">{img.title}</h4>
											<img src={img.src} alt={img.title} />
										</div>
										))
									)}

									{/* Inside Font Management images */}
									{Object.keys(insidefontManagementImages).map((radiusKey) =>
										this.state.infoSliderName === radiusKey &&
										insidefontManagementImages[radiusKey].map((img, i) => (
										<div key={`${radiusKey}-${i}`}>
											<h4 className="settings-notes-slide-title">{img.title}</h4>
											<img src={img.src} alt={img.title} />
										</div>
										))
									)}
								</Slider>
							</div>
						</div>
						{/* Shadow Management End */}

						<div className="title">
							<h4>Radius Management</h4>
						</div> 
						<div className="form-row">		
							<div className="form-left">					
								<div className="form-group">					
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "pluginRadius")}
									>
										Plugin Radius (px):
										{Object.keys(radiusImages).includes("pluginRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="pluginRadius"  onChange={this.handleInputChange}  value={this.state.pluginRadius} />
									<div className="errorpluginRadius"></div>
								</div>
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "inputRadius")}
									>
										Input Box Radius (px):
										{Object.keys(radiusImages).includes("inputRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="inputRadius"  onChange={this.handleInputChange} value={this.state.inputRadius}/>
									<div className="errorinputRadius"></div>
								</div>	
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "dashboardGridRadius")}
									>
										Dashboard Grid Radius (px):
										{Object.keys(radiusImages).includes("dashboardGridRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="dashboardGridRadius"  onChange={this.handleInputChange} value={this.state.dashboardGridRadius}/>
									<div className="errordashboardGridRadius"></div>
								</div>	
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "listRowRadius")}
									>
										List Row Radius (px):
										{Object.keys(radiusImages).includes("listRowRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="listRowRadius"  onChange={this.handleInputChange} value={this.state.listRowRadius}/>
									<div className="errorlistRowRadius"></div>
								</div>	
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "formGroupRadius")}
									>
										Form Group Radius (px):
										{Object.keys(radiusImages).includes("formGroupRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="formGroupRadius"  onChange={this.handleInputChange} value={this.state.formGroupRadius}/>
									<div className="errorformGroupRadius"></div>
								</div>	
							</div>
							<div className="form-right">					
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "dropdownRadius")}
									>
										Dropdown Radius (Bell notification, Grouping menu listing) (px):
										{Object.keys(radiusImages).includes("dropdownRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="dropdownRadius"  onChange={this.handleInputChange}  value={this.state.dropdownRadius} />
									<div className="errordropdownRadius"></div>
								</div>
								<div className="form-group">									
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "textareaRadius")}
									>
										Textarea Radius (AI screen textarea, Invite friend textarea) (px):
										{Object.keys(radiusImages).includes("textareaRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="textareaRadius"  onChange={this.handleInputChange} value={this.state.textareaRadius}/>
									<div className="errortextareaRadius"></div>
								</div>
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "dashboardListRadius")}
									>
										Dashboard List Radius (px):
										{Object.keys(radiusImages).includes("dashboardListRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="dashboardListRadius"  onChange={this.handleInputChange} value={this.state.dashboardListRadius}/>
									<div className="errordashboardListRadius"></div>
								</div>
								<div className="form-group">
									<label
									onClick={this.handleSettingsNotesOpenPopup.bind(this, "imageSliderRadius")}
									>
										Image Slider Radius (px):
										{Object.keys(radiusImages).includes("imageSliderRadius") && (
											<i className="fa fa-info-circle ms-2"></i>
										)}
									</label>
									<input type="text" className="form-control" name="imageSliderRadius"  onChange={this.handleInputChange} value={this.state.imageSliderRadius}/>
									<div className="errorimageSliderRadius"></div>
								</div>
							</div>
						</div>

						{/* Font Management End */}
						<div className="title">
							<h4>Font Management</h4>
						</div> 
						<div className="form-row">		
							<div className="form-left">					
								<div className="form-group">
									<label onClick={this.handleSettingsNotesOpenPopup.bind(this, "line_height")}>Line Height: {Object.keys(fontManagementImages).includes("line_height") && (
											<i className="fa fa-info-circle ms-2 cursor-pointer fs-6"></i>
										)}</label>
									<input type="text" className="form-control" name="line_height" onChange={this.handleInputChange}  value={this.state.line_height}/>
									<div className="errorline_height"></div>
								</div>
							</div>
						</div>
					
						{this.addMoreFunc()}	
						{/* Font Management End */}


						<div className="btn-group export">
							<button
								className="btn btn_orange btn_minwid login_submit animate-btn2"
								//type="submit"
								type='button'
								//onClick={() => this.setState({ formAction: "clone", title : this.state.title+' Copy' })}
								onClick={() => this.confirmThemePopup(this.state.title)}
								disabled={this.state.LoadingCloneBtn}
								style={{ marginRight: "10px" }}
							>
								{this.state.LoadingCloneBtn && <span className="load-data"></span>} Save As New
							</button>

							<button
								className="btn btn_orange btn_minwid login_submit animate-btn2"
								type="submit"
								onClick={() => this.setState({ formAction: "edit" })}
								disabled={this.state.Loading}
							>
								{this.state.Loading && <span className="load-data"></span>} Submit
							</button>
						</div>
					</form>
				</div>				
			</div>	
		</div>	
    </div>
    );
  }
}

export default withRouter(Edit);